// Função pura: um AvisoSistema atinge um perfil quando não tem
// departamento_alvo (vale pra todo staff) ou quando o departamento do perfil
// (legado ou o array novo) bate com o alvo, ignorando acento/caixa/hífen —
// reaproveita a mesma normalização de src/lib/departamentos.ts
// (normalizarDepartamento), espelhada em SQL por
// public.normalizar_departamento() (ver migration 20260825121000).
//
// Usada em dois lugares: AvisosSistemaGate.tsx (o que está pendente pra mim
// agora) e AvisosSistemaView.tsx (quantas pessoas um aviso alcança, pro
// contador de confirmações do painel de gestão) — mesma função, dois usos.

import { normalizarDepartamento } from './departamentos.ts';

export interface AvisoParaAlvo {
    departamento_alvo: string | null;
}

export interface PerfilParaAlvo {
    departamento?: string | null;
    departamentos?: string[] | null;
}

export function avisoAlvejaPerfil(aviso: AvisoParaAlvo, perfil: PerfilParaAlvo): boolean {
    if (!aviso.departamento_alvo) return true;
    const alvo = normalizarDepartamento(aviso.departamento_alvo);
    if (normalizarDepartamento(perfil.departamento) === alvo) return true;
    return (perfil.departamentos ?? []).some((d) => normalizarDepartamento(d) === alvo);
}
